// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-select.select {
  margin: 0px;
}

.row {
  align-items: center;
  white-space: nowrap;
  display: flex;
}

.red {
  color: #d3001d;
}

.globalLimit {
  padding-bottom: 10px;
}

.timeDelete, .timeRolloverPeriod, .timeRemoved, .timeAmountUsed, .timeNewLimitEffective {
  display: none;
}

.custom-select-wrapper {
  margin-top: 8px;
}

.input {
  display: inline-block;
}

.button-row {
  justify-content: center;
  display: grid;
}

.deposit-column {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 0px;
}

.label-colum {
  display: flex;
  align-items: center;
}

.lossMonthlyCurrentLimit {
  white-space: nowrap;
}

.lossDelete {
  display: none;
}

.label-text {
  text-overflow: "-";
  white-space: nowrap;
}

.deposit-column {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

hr {
  border: 0;
  height: 1px;
  background: #C2C2C2;
}

ion-input {
  --ion-margin: 0.5rem;
}

.limit-input-error {
  font-size: 14px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/limits-table-row/limits-table-row.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;;AAGI;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;AAAR;;AAGI;EACI,cAAA;AAAR;;AAGI;EACI,oBAAA;AAAR;;AAGI;EACI,aAAA;AAAR;;AAGI;EACI,eAAA;AAAR;;AAGI;EACI,qBAAA;AAAR;;AAGI;EACI,uBAAA;EACA,aAAA;AAAR;;AAII;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AADR;;AAII;EACI,aAAA;EACA,mBAAA;AADR;;AAII;EACI,mBAAA;AADR;;AAII;EACI,aAAA;AADR;;AAII;EACI,kBAAA;EACA,mBAAA;AADR;;AAII;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADR;;AAII;EACI,SAAA;EACA,WAAA;EACA,mBAAA;AADR;;AAII;EACI,oBAAA;AADR;;AAII;EACI,0BAAA;AADR","sourcesContent":["\n    ion-select.select {\n        margin: 0px;\n    }\n    \n    .row {\n        align-items: center;\n        white-space: nowrap;\n        display: flex;\n    }\n\n    .red {\n        color: #d3001d;\n    }\n\n    .globalLimit {\n        padding-bottom: 10px;\n    }\n\n    .timeDelete, .timeRolloverPeriod, .timeRemoved, .timeAmountUsed, .timeNewLimitEffective {\n        display: none;\n    }\n\n    .custom-select-wrapper {\n        margin-top: 8px;\n    }\n\n    .input {\n        display: inline-block;\n    }\n\n    .button-row {\n        justify-content: center;\n        display: grid;\n        \n    }\n\n    .deposit-column {\n        flex-direction: row;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        flex-wrap: wrap;\n        padding: 0px;\n    }\n\n    .label-colum {\n        display: flex;\n        align-items: center;\n    }\n\n    .lossMonthlyCurrentLimit {\n        white-space: nowrap;\n    }\n\n    .lossDelete {\n        display: none\n    }\n\n    .label-text {\n        text-overflow: \"-\";\n        white-space: nowrap;\n    }\n\n    .deposit-column {\n        flex-direction: row;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n    \n    hr {\n        border: 0;\n        height: 1px;\n        background: #C2C2C2;\n    }\n\n    ion-input {\n        --ion-margin: 0.5rem; \n    }\n\n    .limit-input-error{\n        font-size:14px !important;\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
